import React from 'react'
import { cn } from '../../utils/cn';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useLocationContext } from '../../hooks/useLocationContext';
import { pushInteractionEvent } from '../../services/gtmService';

export type TabsOptions = 'promotions' | 'stores';

type TabsProps = {
    selectedTab: TabsOptions,
    setSelectedTab: React.Dispatch<React.SetStateAction<TabsOptions>>,
}
const Tabs = ({ selectedTab, setSelectedTab }: TabsProps) => {

    const { userData } = useAuthContext();
    const { locationUserData } = useLocationContext()

    const handleClickStores = () => {
        pushInteractionEvent('interaction_home', 'Centros de canje');
        if (userData.isLogged && locationUserData.locationType !== 'none') {
            setSelectedTab('stores')
        }
    }

    const handleClickPromotions = () => {
        pushInteractionEvent('interaction_home', 'Promociones');
        setSelectedTab('promotions');
    }

    return (
        <div className='flex justify-between gap-8'>
            <div id='tabPromotions' className={cn('font-roboto font-semibold text-sm text-blue_text px-3 py-1 cursor-pointer', selectedTab === 'promotions' && 'text-white bg-[#5553BE] rounded-t-[4px] border-b border-[#100E9D]')} onClick={handleClickPromotions}>
                Promociones
            </div>
            <div id='tabStores' className={cn('step5 font-roboto font-semibold text-sm text-blue_text px-3 py-1 cursor-pointer', selectedTab === 'stores' && 'text-white bg-[#5553BE] rounded-t-[4px]', (!userData.isLogged || locationUserData.locationType === 'none') && 'text-[#95A2AD]')} onClick={handleClickStores}>
                Centros de canje
            </div>
        </div>
    )
}

export default Tabs
